import React, { createContext, useContext, useState, useEffect, useRef } from 'react';
import axiosClient from '../../common/axiosInstance';
import { useHistory } from 'react-router-dom';
import { useThemeContext } from 'contexts/ThemeContext';

const OtoContext = createContext();

export const useOtoContext = () => useContext(OtoContext);
export const DOCTYPE_STATUS = {
  IDLE: null,
  SUCCESS: "1",
  WARNING: "warning",
  ERROR: "2",
  LOADING: "loading",
  HANDLING: "3",
  CHECKING: "4", // đang kiểm tra
}
// IDLE: null,
//   1: 'success',
//   WARNING: 'warning',
//   2: 'error',
//   LOADING: 'info',
export default ({ children }) => {
  const history = useHistory();
  const SC_CODE = 'AUTO';
  const PSCS_PDS_CODE = '1103';

  const [requestId, setRequestId] = useState('');

  const [isFetchInsuranceDetailDone, setFetchInsuranceDetailDone] = useState(false);
  const [insuranceData, setInsuranceData] = useState({});
  const [currentStatusStep, setCurrentStatusStep] = useState(0);
  const [paymentErrors, setPaymentErrors] = useState({
    method: '',
  });

  const timer = useRef(null);
  useEffect(() => {
    let fbIcon = null;
    timer.current = setInterval(() => {
      fbIcon = document.getElementById('fb-root');
      if (fbIcon) {
        fbIcon.style.display = 'none';
        clearInterval(timer.current);
      }
    }, 3000);
    return () => {
      fbIcon = document.getElementById('fb-root');
      if (fbIcon) {
        fbIcon.style.display = 'block';
      }
      clearInterval(timer.current);
    };
  }, []);
  // fetch initial data
  useEffect(() => {
    apiFetchListMaster();
  }, []);

  useEffect(() => {
    apiGetInsuranceDetail();
  }, [requestId]);
  useEffect(() => {
    localStorage.setItem('insuranceData-partnerId', insuranceData.partnerId);
  }, [insuranceData.partnerId]);

  const [inforInsurance, setInforInsurance] = useState({
    name: '',
    phoneNumber: '',
    email: '',
    address: '',
    //
    policyPurpose: '',
    vehicleType: '',
    licenseId: '',
    vehicleMake: '',
    vehicleModel: '',
    vehicleYear: '',
    capacity: '',
  });
  // list master
  const [vehicleType, setVehicleType] = useState([]);
  const [policyPurpose, setPolicyPurpose] = useState([]);
  const [vehicleMake, setVehicleMake] = useState([]);
  const [standardBenefitSale, setStandardBenefitSale] = useState([]);
  const [hightBenefitSale, setHightBenefitSale] = useState([]);

  const handleChangeInfoInsurance = (name, val) => {
    setInforInsurance((prev) => {
      return {
        ...prev,
        [name]: val,
      };
    });
  };

  const [paymentData, setPaymentData] = useState({
    method: '',
  });
  const handleChangePaymentData = (name, val) => {
    setPaymentData((prev) => {
      return {
        ...prev,
        [name]: val,
      };
    });
    setPaymentErrors((prev) => ({
      ...prev,
      [name]: '',
    }));
  };

  const [isLoading, setLoading] = useState(0);
  const handleLoading = (loading = true) => {
    if (loading) {
      setLoading((prev) => prev + 1);
      return;
    }
    setLoading((prev) => prev - 1);
  };
  // stepper
  const [stepper, setStepper] = useState([
    { label: 'Thông tin xe', status: 'active' },
    { label: 'Chọn quyền lợi', status: 'disabled' },
    { label: 'Chụp hình xe', status: 'disabled' },
    { label: 'Thông tin bảo hiểm', status: 'disabled' },
    { label: 'Xác nhận thanh toán', status: 'disabled' },
  ]);
  const handleChangeStep = (step) => {
    step = step - 1;
    if (step < 0) return;
    setStepper((prev) => {
      const steps = prev.map((x, i) => {
        if (step < i) {
          return {
            ...x,
            status: 'disabled',
          };
        }
        if (step > i) {
          return {
            ...x,
            status: 'completed',
          };
        }
        return {
          ...x,
          status: 'active',
        };
      });
      return steps;
    });
  };

  const handleNavigatePage = (status) => {
    if (!requestId) return;
    switch (Number(status)) {
      case 1:
        const partnerId = insuranceData.partnerId;
        if (!partnerId) return;
        history.push('/insurance-car/input-informations/' + partnerId);
        break;
      case 2:
        history.push('/insurance-car/choose-benefits/' + requestId);
        break;
      case 3:
        history.push('/insurance-car/expertise/' + requestId);
        break;
      case 4:
        history.push('/insurance-car/input-informations-insurance/' + requestId);
        break;
      case 5:
        history.push('/insurance-car/review-information/' + requestId);
        break;
      case 6:
        history.push('/insurance-car/payment-result/' + requestId);
        break;
      default:
      // history.push("/insurance-car/input-informations")
    }
  };
  const handleClickStep = ({ label, status, index }) => {
    // if (index === 1) return;
    if (insuranceData.status_code && index > Number(insuranceData.status_code)) return;
    handleNavigatePage(index);
  };

  // api
  const apiGetInsuranceDetail = () => {
    if (!requestId) return;
    handleLoading(true);
    return axiosClient
      .get('/sale-autocare/get-detail-order?ld_request_id=' + requestId)
      .then((res) => {
        setInsuranceData((prev) => {
          return { ...prev, ...res.data };
        });
        handleNavigatePage(res.data.status_code);
        setCurrentStatusStep(res.data.status_code);
      })
      .finally(() => {
        setFetchInsuranceDetailDone(true);
        handleLoading(false);
      });
  };
  const apiFetchListMaster = () => {
    handleLoading(true);
    const getListPolicyPurpose = () => {
      return axiosClient.get('/get-list-master?code=POLICY_PURPOSE');
    };
    // const getListVehicleYear = () => {
    //     return axiosClient.get("/get-list-master?code=VEHICLE_YEAR")
    // }
    const getListVehicleType = () => {
      return axiosClient.get('/get-list-master?code=VEHICLE_TYPE');
    };
    const getListVehicleMake = () => {
      return axiosClient.get('/sale-autocare/get-make-vehicle');
    };
    const getStandardBenefitSale = () => {
      return axiosClient.get('/get-list-master-sale?code=STANDARD_BENEFIT_SALE');
    };
    const getHightBenefitSale = () => {
      return axiosClient.get('/get-list-master-sale?code=HIGHT_BENEFIT_SALE');
    };
    Promise.all([
      getListPolicyPurpose(),
      getListVehicleType(),
      getListVehicleMake(),
      getStandardBenefitSale(),
      getHightBenefitSale(),
    ])
      .then((values) => {
        setPolicyPurpose(values[0].data);
        setVehicleType(values[1].data);
        setVehicleMake(values[2].data);
        setStandardBenefitSale(values[3].data);
        setHightBenefitSale(values[4].data);
      })
      .finally(() => {
        handleLoading(false);
      });
  };
  return (
    <OtoContext.Provider
      value={{
        SC_CODE,
        PSCS_PDS_CODE,
        isFetchInsuranceDetailDone,
        apiGetInsuranceDetail,
        currentStatusStep,
        // list master
        vehicleType,
        policyPurpose,
        vehicleMake,
        standardBenefitSale,
        hightBenefitSale,
        //1
        loading: isLoading > 0,
        handleLoading,
        setRequestId,
        requestId,
        stepper,
        handleChangeStep,
        handleClickStep,
        handleChangeInfoInsurance,
        inforInsurance,
        setInforInsurance,
        // 2
        setInsuranceData,
        insuranceData,
        apiFetchListMaster,
        paymentData,
        handleChangePaymentData,
        paymentErrors,
        setPaymentErrors,
      }}
    >
      {children}
    </OtoContext.Provider>
  );
};
